<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page">
    <h1>Verify Email</h1>
    <div class="loan-section max-w-500 w-full">
      @if (isLoading) {
        <p class="m-0">Verifying your email…</p>
      } @else {
        @if (message) {
          <p class="m-0">{{ message }}</p>
        }
        @if (error) {
          <p class="m-0 text-err">{{ error }}</p>
        }
        <div class="flex justify-between items-center pt-10">
          <app-button [onClick]="goToLogin">Continue to Sign In</app-button>
        </div>
      }
    </div>
  </main>
</body>

